// extracted by mini-css-extract-plugin
export default {"articlesRow":"article-banner_articlesRow__bEuoc"};